function suggest(query, street_id) {
    let serviceUrl = `https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address`;
    const cityMap = {
        7700000000000: 'москва',
        7800000000000: 'санкт-петербург'
    };

    let locations = [{
        city: cityMap[kladr],
        kladr_id: cityMap[kladr] ? undefined : kladr,
        street_fias_id: street_id
    }];

    let request = {
        query: query,
        count: 20,
        locations,
        from_bound: {value: "street"},
        to_bound: {value: "house"},
    };

    let params = {
        method: "POST",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + token,
        },
        body: JSON.stringify(request),
    };
    return fetch(serviceUrl, params);
}

export default suggest;
